import { render, staticRenderFns } from "./ActivationExpiredPage.vue?vue&type=template&id=e48cdf74&scoped=true&"
import script from "./ActivationExpiredPage.vue?vue&type=script&lang=ts&"
export * from "./ActivationExpiredPage.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e48cdf74",
  null
  ,true
)

/* custom blocks */
import block0 from "../locale/ActivationExpiredPage.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdatavg%2Fbamboo-agent-home-3%2Fxml-data%2Fbuild-dir%2FCPSDE-CPKUNB0-DOC%2Fsrc%2Fpages%2FActivationExpiredPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports